
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.557 12.378h-1.861a.138.138 0 01-.134-.141V6.763c0-.078.06-.142.134-.142h1.861c.405 0 .794-.177 1.066-.487a1.52 1.52 0 00.373-1.12c-.054-.777-.675-1.386-1.414-1.386h-1.886a.138.138 0 01-.134-.141V1.523c0-.427-.169-.838-.462-1.125a1.348 1.348 0 00-1.061-.394c-.737.057-1.313.713-1.313 1.493v1.99c0 .078-.06.141-.134.141H6.406a.138.138 0 01-.134-.141V1.523A1.58 1.58 0 005.81.398 1.348 1.348 0 004.75.004c-.736.057-1.313.713-1.313 1.493v1.99c0 .078-.06.141-.134.141h-1.86c-.404 0-.793.178-1.065.487a1.52 1.52 0 00-.373 1.12c.054.777.675 1.386 1.414 1.386h1.884c.074 0 .134.064.134.142v5.474c0 .078-.06.141-.134.141h-1.86c-.404 0-.793.178-1.065.488a1.52 1.52 0 00-.373 1.12c.054.777.675 1.386 1.414 1.386h1.884c.074 0 .134.063.134.141v1.964c0 .427.168.837.461 1.125.29.285.667.424 1.062.394.736-.057 1.313-.713 1.313-1.493v-1.99c0-.078.06-.141.134-.141h5.186c.073 0 .134.063.134.141v1.964c0 .427.168.838.461 1.125a1.353 1.353 0 001.062.394c.736-.057 1.313-.713 1.313-1.493v-1.99c0-.078.06-.141.134-.141h1.886c.74 0 1.36-.61 1.414-1.386a1.52 1.52 0 00-.373-1.12 1.424 1.424 0 00-1.066-.488zm-4.831-.141c0 .078-.06.141-.134.141H6.406a.138.138 0 01-.134-.141V6.763c0-.078.06-.142.134-.142h5.186c.073 0 .134.064.134.142v5.474z"}})])
          )
        }
      }
    